import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "styles/global-styles.scss";
import { store } from "utils/redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root")!;
const root = createRoot(container);

// Strict mode is commented out because when working in strict mode, the plugins for chart js do not work locally.
// REMEMBER: Uncomment this when pushing to production.
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
